import appStore from "./AppModel";
import { FiveYearPlanListModel } from "./modules/5yearplan/FiveYearPlanListModel";
import {
  FiveYearPlanHeaderModel,
  FiveYearPlanModel,
} from "./modules/5yearplan/FiveYearPlanModel";
import authStore from "./modules/auth/AuthModel";
import userStore from "./modules/auth/UserModel";
import { ExistingDebtPlanListModel } from "./modules/existingdebtplan/ExistingDebtPlanListModel";
import { FinancialReportListModel } from "./modules/financial/FinancialReportListModel";
import { MonthlyReportListModel } from "./modules/monthlyreport/MonthlyReportListModel";
import { NewDebtPlanListModel } from "./modules/newdebtplan/NewDebtPlanListModel";
import { OrganizeChangeRequestListModel } from "./modules/org/OrganizeChangeRequestListModel";
import { OrganizeDashboardModel } from "./modules/org/OrganizeDashboardModel";
import { OrganizeListModel } from "./modules/org/OrganizeListModel";
import { LOVGroupModel, OrganizeModel } from "./modules/org/OrganizeModel";
import { ProjectListModel } from "./modules/project/ProjectListModel";
import { ProposalPlanListModel } from "./modules/proposalplan/ProposalPlanListModel";
import { RegulationListModel } from "./modules/regulations/RegulationModel";
import { SelectListGroupModel } from "./modules/systemhelper/SelectListGroupModel";
import { TechnicalAssistListModel } from "./modules/techassist/TechnicalAssistListModel";
import { TechnicalAssistModel } from "./modules/techassist/TechnicalAssistModel";
import { YearPlanDashboardModel } from "./modules/yearplan/YearPlanDashboardModel";
import { FilterSummarySdg,SdgSummarySdgModel } from "./modules/sdgs/SdgDashboardModel";
import { NewDebtPlanModel } from "./modules/newdebtplan/NewDebtPlanModel";
import { ProjectDropdownStore } from "./modules/project/ProjectDropdownStore";
import { LogListModel, PlanLogListModel } from "./modules/logs/LogListModel";
import { LogFiveYearPlanBodyModel, LogFiveYearPlanItem } from "./modules/logs/LogFiveYearPlanBodyModels";
import { LogNewDebtPlanModel } from "./modules/logs/LogNewDebtPlanModel";

const organizeStore = OrganizeModel.create({ changeRequest: {} });
const technicalAssistListStore = TechnicalAssistListModel.create({});
const selectedTechAssistStore = TechnicalAssistModel.create({});
const affiliatesStore = SelectListGroupModel.create({});
const orgTypeStore = LOVGroupModel.create({});
const fieldStore = LOVGroupModel.create({});
const subFieldStore = LOVGroupModel.create({});
const organizeDashboardStore = OrganizeDashboardModel.create({});
const publicDebtLawTypeStore = LOVGroupModel.create({});
const financelLawTypeStore = LOVGroupModel.create({});
const debtCalculationStore = LOVGroupModel.create({});
const organizeListStore = OrganizeListModel.create({});
const organizeChangeRequestListStore = OrganizeChangeRequestListModel.create(
  {},
);
const fiveYearPlanHeaderStore = FiveYearPlanHeaderModel.create({});
const fiveYearPlanListStore = FiveYearPlanListModel.create({});
const fiveYearPlanStore = FiveYearPlanModel.create({});
const fiveYearFilterTypeStore = LOVGroupModel.create({});
const newDebtPlanFilterTypeStore = LOVGroupModel.create({});
const existingDebtPlanFilterTypeStore = LOVGroupModel.create({});
const financialReportFilterTypeStore = LOVGroupModel.create({});
const proposalPlanFilterTypeStore = LOVGroupModel.create({});
const documentObjectiveStore = LOVGroupModel.create({});
const projectTypeStore = LOVGroupModel.create({});
const projectListStore = ProjectListModel.create({});
const fiveYearProjectTypeStore = SelectListGroupModel.create({});
const fiveYearPlanDashboardStore = FiveYearPlanListModel.create({});
const newDebtPlanListStore = NewDebtPlanListModel.create({});
const existingDebtPlanListStore = ExistingDebtPlanListModel.create({});
const financialReportListStore = FinancialReportListModel.create({});
const yearPlanDashboardStore = YearPlanDashboardModel.create({});
const proposalPlanListStore = ProposalPlanListModel.create({});
const proposalStatusStore = LOVGroupModel.create({});
const planStatusStore = LOVGroupModel.create({});
const monthlyReportListStore = MonthlyReportListModel.create({});
const regulationListStore = RegulationListModel.create({});
const regulationTemplateListStore = LOVGroupModel.create({});
const existingDebtStore = LOVGroupModel.create({});
const existingDebtPlanTypeStore = LOVGroupModel.create({});
const sdgStore = LOVGroupModel.create({});
const sdgSubStore = LOVGroupModel.create({});
const sdgSummarySdgStore = SdgSummarySdgModel.create({});
const filterSummarySdgStore = FilterSummarySdg.create({});
const newDebtPlan = NewDebtPlanModel.create({});
const projectDropdownStore = ProjectDropdownStore.create({});
const LogListStore = LogListModel.create({});
const PlanLogListStore = PlanLogListModel.create({}); 
const LogFiveYearPlanStore = LogFiveYearPlanBodyModel.create({});
const LogFiveYearPlanItemStore = LogFiveYearPlanItem.create({});
const LogNewDebtPlanStore = LogNewDebtPlanModel.create({});

const RootStore = {
  appStore,
  authStore,
  organizeStore,
  userStore,
  technicalAssistListStore,
  selectedTechAssistStore,
  orgTypeStore,
  fieldStore,
  subFieldStore,
  organizeDashboardStore,
  publicDebtLawTypeStore,
  financelLawTypeStore,
  debtCalculationStore,
  affiliatesStore,
  organizeListStore,
  organizeChangeRequestListStore,
  fiveYearPlanHeaderStore,
  fiveYearPlanListStore,
  fiveYearPlanStore,
  fiveYearFilterTypeStore,
  newDebtPlanFilterTypeStore,
  existingDebtPlanFilterTypeStore,
  financialReportFilterTypeStore,
  proposalPlanFilterTypeStore,
  documentObjectiveStore,
  projectTypeStore,
  projectListStore,
  fiveYearProjectTypeStore,
  fiveYearPlanDashboardStore,
  newDebtPlanListStore,
  existingDebtPlanListStore,
  financialReportListStore,
  proposalPlanListStore,
  proposalStatusStore,
  monthlyReportListStore,
  yearPlanDashboardStore,
  planStatusStore,
  regulationListStore,
  regulationTemplateListStore,
  existingDebtStore,
  existingDebtPlanTypeStore,
  sdgStore,
  sdgSubStore,
  sdgSummarySdgStore,
  filterSummarySdgStore,
  newDebtPlan,
  projectDropdownStore,
  LogListStore,
  PlanLogListStore,
  LogFiveYearPlanStore,
  LogFiveYearPlanItem,
  LogFiveYearPlanItemStore,
  LogNewDebtPlanStore
};
export default RootStore;
